var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", {
  value,
  configurable: true
});

// src/suiteFeatures.ts
var suiteFeatureGroupings = [{
  key: "featureGroup_characteristics",
  title: "Characteristics",
  features: [{
    key: "feature_balconyWindow",
    title: "Balcony / Window",
    type: "options",
    options: [{
      key: "feature_balconyWindow_portholes",
      label: "Portholes"
    }, {
      key: "feature_balconyWindow_window",
      label: "Window"
    }, {
      key: "feature_balconyWindow_largePictureWindow",
      label: "Large Balcony Window"
    }, {
      key: "feature_balconyWindow_floorToCeilingWindow",
      label: "Floor-to ceiling window"
    }, {
      key: "feature_balconyWindow_veranda",
      label: "Veranda"
    }, {
      key: "feature_balconyWindow_frenchBalcony",
      label: "French Balcony"
    }, {
      key: "feature_balconyWindow_horizonBalcony",
      label: "Horizon Balcony"
    }, {
      key: "feature_balconyWindow_floorToCeilingGlassDoors",
      label: "Large Veranda with floor-to-ceiling glass doors"
    }],
    caveat: true
  }, {
    key: "feature_separateDiningArea",
    title: "Separate dining area",
    type: "boolean"
  }, {
    key: "feature_sittingArea",
    title: "Separated sitting area / sitting area",
    type: "options",
    options: [{
      key: "feature_sittingArea_sittingArea",
      label: "Sitting area"
    }, {
      key: "feature_sittingArea_livingRoom",
      label: "Living room with sitting area"
    }]
  }, {
    key: "feature_vanity",
    title: "Vanity",
    type: "options",
    options: [{
      key: "feature_vanity_standardVanity",
      label: "Standard Vanity"
    }, {
      key: "feature_vanity_largeVanity",
      label: "Large Vanity"
    }, {
      key: "feature_vanity_doubleVanity",
      label: "Double Vanity"
    }]
  }, {
    key: "feature_shower",
    title: "Shower",
    type: "options",
    options: [{
      key: "feature_shower_separate",
      label: "Separate shower"
    }, {
      key: "feature_shower_walkin",
      label: "Walk-in shower"
    }],
    caveat: true
  }, {
    key: "feature_bath",
    title: "Bath",
    type: "options",
    notPresentLabel: "No bath",
    options: [{
      key: "feature_bath_someWithFullSize",
      label: "Some with full-size bath"
    }, {
      key: "feature_bath_fullSize",
      label: "Full-size bath"
    }, {
      key: "feature_bath_whirlpool",
      label: "Whirlpool bath"
    }],
    caveat: true
  }, {
    key: "feature_walkInWardrobe",
    title: "Walk-in wardrobe with personal safe",
    type: "boolean",
    caveat: true
  }]
}, {
  key: "featureGroup_furniture",
  title: "Furniture",
  features: [{
    key: "feature_beds",
    title: "Beds",
    type: "options",
    options: [{
      label: "Queen size bed",
      key: "feature_beds_queen"
    }, {
      label: "Queen size bed or Twin beds",
      key: "feature_beds_queenOrTwinBeds"
    }, {
      label: "King size bed",
      key: "feature_beds_king"
    }, {
      label: "Twin beds or king-size bed",
      key: "feature_beds_twinOrKing"
    }, {
      label: "Twin beds or king-size bed and a single bed in additional bedroom",
      key: "feature_beds_twinOrKingWithAdditionalSingle"
    }]
  }, {
    key: "feature_writingDesk",
    title: "Writing desk",
    type: "boolean"
  }, {
    key: "feature_vanityTable",
    title: "Vanity table",
    type: "boolean"
  }, {
    key: "feature_customMadeMattress",
    title: "Luxury bed mattresses",
    type: "boolean",
    caveat: true
  }]
}, {
  key: "featureGroup_mediaAndCommunication",
  title: "Media & Communication",
  features: [{
    key: "feature_wifi",
    title: "Wi-Fi connection",
    type: "options",
    options: [{
      label: "Unlimited Premium Wi-Fi",
      key: "feature_wifi_premium"
    }, {
      label: "Unlimited Standard Wi-Fi",
      key: "feature_wifi_standard"
    }]
  }, {
    key: "feature_tvCount",
    title: "Number of TV(s) with interactive media library",
    type: "options",
    options: [{
      label: "1",
      key: "feature_tvCount_1"
    }, {
      label: "2",
      key: "feature_tvCount_2"
    }, {
      label: "3",
      key: "feature_tvCount_3"
    }, {
      label: "4",
      key: "feature_tvCount_4"
    }]
  }, {
    key: "feature_soundSystem",
    title: "Sound system with bluetooth connectivity",
    type: "boolean"
  }, {
    key: "feature_telephone",
    title: "Direct dial telephone",
    type: "boolean"
  }, {
    key: "feature_usbCChargers",
    title: "Wall mounted USB-C mobile device chargers",
    type: "boolean"
  }, {
    key: "feature_dualVoltageOutlets",
    title: "Dual voltage 110/220 outlets",
    type: "boolean"
  }]
}, {
  key: "featureGroup_onboardServices",
  title: "Onboard Services",
  features: [{
    key: "feature_butlerService",
    title: "Butler service",
    type: "boolean"
  }, {
    key: "feature_complimentaryLaundry",
    title: "Complimentary laundry, pressing & wet cleaning",
    type: "boolean",
    caveat: true
  }, {
    key: "feature_canapeService",
    title: "Daily canape service, Welcome chocolate, Welcome fruit stand",
    type: "boolean"
  }, {
    key: "feature_dinnerAtOfficersTable",
    title: "Dinner at the officer\u2019s table",
    type: "boolean"
  }, {
    key: "feature_dinnerInLaDame",
    title: "Dinner for two in La Dame, one evening per voyage,",
    type: "boolean"
  }, {
    key: "feature_worldwidePhone",
    title: "Two hours of worldwide phone use, per voyage segment",
    type: "boolean"
  }, {
    key: "feature_priorityCheckin",
    title: "Priority check-in on embarkation day with early suite access",
    type: "boolean"
  }, {
    key: "feature_champagneOnArrival",
    title: "Champagne on arrival",
    type: "boolean"
  }, {
    key: "feature_sparklingWineOnArrival",
    title: "Sparkling wine on arrival",
    type: "boolean"
  }]
}, {
  key: "featureGroup_amenities",
  title: "Amenities",
  features: [{
    key: "feature_espressoMachine",
    title: "Espresso machine",
    type: "boolean"
  }, {
    key: "feature_teaKettles",
    title: "Tea kettles",
    type: "boolean"
  }, {
    key: "feature_pillowMenu",
    title: "Pillow menu",
    type: "boolean"
  }, {
    key: "feature_refrigeratorAndBar",
    title: "Refrigerator and bar setup stocked with your preferences",
    type: "boolean"
  }, {
    key: "feature_bathrobe",
    title: "Plush bathrobe",
    type: "boolean"
  }, {
    key: "feature_bathAmenities",
    title: "Luxury bath amenities",
    type: "boolean"
  }, {
    key: "feature_umbrella",
    title: "Umbrella",
    type: "boolean"
  }, {
    key: "feature_hairDryer",
    title: "Hair Dryer",
    type: "boolean"
  }, {
    key: "feature_slippers",
    title: "Slippers",
    type: "boolean"
  }]
}];
var SUITE_FEATURE_GROUPINGS = suiteFeatureGroupings;

// src/helpers.ts
var grouppedSuiteFeatureValues = /* @__PURE__ */__name(comparableFeatures => SUITE_FEATURE_GROUPINGS.map(grouping => ({
  title: grouping.title,
  features: grouping.features.map(toValue(comparableFeatures)).filter(isPresent)
})), "grouppedSuiteFeatureValues");
var toValue = /* @__PURE__ */__name(comparableFeatures => feature => {
  const value = comparableFeatures[feature.key];
  if (!value) return void 0;
  if (isBoolean(feature)) return feature.key;
  if (isOption(feature)) return value;
  return void 0;
}, "toValue");
var isPresent = /* @__PURE__ */__name(x => x !== void 0, "isPresent");
var isBoolean = /* @__PURE__ */__name(feature => feature.type == "boolean", "isBoolean");
var isOption = /* @__PURE__ */__name(feature => feature.type == "options", "isOption");
export { SUITE_FEATURE_GROUPINGS, grouppedSuiteFeatureValues };